var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDream2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 60,
    viewBox: "0 0 72 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.044 42.1469C30.3926 42.1469 34.4383 38.204 34.4383 29.6669C34.4383 21.1297 30.3926 17.1869 25.044 17.1869C19.6954 17.1869 15.684 21.1297 15.684 29.6669C15.684 38.204 19.6954 42.1469 25.044 42.1469ZM19.6612 29.6669C19.6612 23.2897 21.924 20.3069 25.044 20.3069C28.164 20.3069 30.4269 23.2897 30.4269 29.6669C30.4269 36.044 28.164 39.0269 25.044 39.0269C21.924 39.0269 19.6612 36.044 19.6612 29.6669Z",
    fill: "#680ADC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4775 30.9355C40.2946 33.2326 37.2089 35.5983 37.2432 41.6326H53.9404V38.1698H41.6661C42.5575 35.7355 45.3004 34.3983 47.8718 32.924C50.9918 31.1412 53.7004 28.9469 53.7004 24.6612C53.7004 19.964 50.2375 17.1869 45.6775 17.1869C40.4661 17.1869 37.0375 20.7183 37.2432 26.1012H41.1518C41.0489 23.324 42.5232 20.5812 45.5061 20.5812C47.8375 20.5812 49.6889 22.2612 49.6889 24.5926C49.6889 27.404 48.3861 28.7412 44.4775 30.9355Z",
    fill: "#680ADC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.612244 7.347C0.612244 3.62752 3.62746 0.612305 7.34694 0.612305H15.9184V4.28577H7.34694C5.65627 4.28577 4.28571 5.65633 4.28571 7.347V15.9184H0.612244V7.347Z",
    fill: "#680ADC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4082 7.347C70.4082 3.62752 67.393 0.612305 63.6735 0.612305H55.1021V4.28577H63.6735C65.3641 4.28577 66.7347 5.65633 66.7347 7.347V15.9184H70.4082V7.347Z",
    fill: "#680ADC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4082 52.6531C70.4082 56.3726 67.393 59.3878 63.6735 59.3878H55.1021V55.7143H63.6735C65.3641 55.7143 66.7347 54.3437 66.7347 52.6531V44.0817H70.4082V52.6531Z",
    fill: "#680ADC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.612244 52.6531C0.612244 56.3726 3.62746 59.3878 7.34694 59.3878H15.9184V55.7143H7.34694C5.65627 55.7143 4.28571 54.3437 4.28571 52.6531V44.0817H0.612244V52.6531Z",
    fill: "#680ADC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDream2);
export default __webpack_public_path__ + "static/media/dream2.bfa32bd0d353c62fb7f7702feb4c1fb0.svg";
export { ForwardRef as ReactComponent };